export const SET_ENVIRONMENT_VARIABLES = 'SET_ENVIRONMENT_VARIABLES'
